import { render, staticRenderFns } from "./EditPhotos.vue?vue&type=template&id=6b9a7f75&scoped=true"
import script from "./EditPhotos.vue?vue&type=script&lang=js"
export * from "./EditPhotos.vue?vue&type=script&lang=js"
import style0 from "./EditPhotos.vue?vue&type=style&index=0&id=6b9a7f75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9a7f75",
  null
  
)

export default component.exports